<div class="flex flex-row h-full justify-start overflow-hidden">
  <sd-viewer-list class="border-r border-gray-1 w-72"></sd-viewer-list>
  <sd-viewer-web3d class="flex-grow h-full"></sd-viewer-web3d>
</div>
